import { render } from "./TotalParticipant.vue?vue&type=template&id=052ca494"
import script from "./TotalParticipant.vue?vue&type=script&lang=js"
export * from "./TotalParticipant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__